import { IConnection } from './IConnection';

export interface IGateway extends IConnection { }